import { Button, Checkbox, Grid} from "@mui/material";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Column, TableInstance } from "react-table";
import { apiStore } from "../../../api/ApiFactory";
import { MainCard } from "../../../components/surface/MainCard";
import { ReactTable } from "../../../components/table/ReactTable";
import { ILookups, Lookup } from "../../../models/Configuration";
import { SelectColumnFilter } from "../../../components/table/filters/SelectColumnFilter";
import TermsLookupTableComponent from "./TableComponents/TermsLookupTableComponent";
import LookupTableComponent from "./TableComponents/LookupTableComponent";

const Lookups = () => {
  const navigate = useNavigate();
  const [pageData, setPageData] = useState<ILookups>();

  useEffect(() => {
    const result = apiStore.lookupApi.getLookups();
    result.then((response: ILookups) => {
      setPageData(response);
    });
  }, []);

  return (
    <Grid container spacing={4} justifyContent="flex-start">
      <Grid item md={12} xs={12}>
        <MainCard title="Terms Options">

          <TermsLookupTableComponent
            data={pageData?.termOptionList ? pageData?.termOptionList : []}
          />

        </MainCard>
      </Grid>
      <Grid item md={12} xs={12}>
        <MainCard title="Requested Delivery">

          <LookupTableComponent
            data={pageData?.requestedDeliveryList ? pageData?.requestedDeliveryList: []}
            name = "Requested Delivery" value="requestedDelivery"
          />

        </MainCard>
      </Grid>
      <Grid item md={12} xs={12}>
        <MainCard title="Shipping">
          <LookupTableComponent
            data={pageData?.freightMethodList ? pageData?.freightMethodList: []}
            name="Shipping" value="shipping"
          />
        </MainCard>
      </Grid>
    </Grid>
  );
};

export default Lookups;
